// Generation orchestrator: prefers a Web Worker (UI stays responsive) and
// transparently falls back to inline execution if workers are unavailable.
import { generateSequence } from "./stringArt";

let worker = null;
let workerBroken = false;

function getWorker() {
  if (workerBroken) return null;
  if (worker) return worker;
  try {
    worker = new Worker(new URL("./stringArt.worker.js", import.meta.url));
  } catch (e) {
    workerBroken = true;
    worker = null;
  }
  return worker;
}

function viaWorker(message, onProgress) {
  return new Promise((resolve, reject) => {
    const w = getWorker();
    if (!w) {
      reject(new Error("worker-unavailable"));
      return;
    }
    const cleanup = () => {
      w.removeEventListener("message", onMsg);
      w.removeEventListener("error", onErr);
    };
    const onMsg = (e) => {
      const d = e.data || {};
      if (d.type === "progress") {
        if (onProgress) onProgress(d.value);
      } else if (d.type === "done") {
        cleanup();
        resolve(d);
      } else if (d.type === "error") {
        cleanup();
        reject(new Error(d.message));
      }
    };
    const onErr = (err) => {
      cleanup();
      workerBroken = true;
      worker = null;
      reject(err);
    };
    w.addEventListener("message", onMsg);
    w.addEventListener("error", onErr);
    // No transferables: keep our copy intact so inline fallback always works.
    w.postMessage(message);
  });
}

export async function generateMono(opts, onProgress) {
  const { error, nails, W, H, numLines, lineWeight, minDist, lengthPenalty } = opts;
  const params = { nails, W, H, numLines, lineWeight, minDist, lengthPenalty };
  try {
    const r = await viaWorker({ type: "mono", error, params }, onProgress);
    return r.sequence;
  } catch (e) {
    return generateSequence({ error, ...params, onProgress });
  }
}

export async function generateMulti(opts, onProgress) {
  const { maps, colors, nails, W, H, numLines, lineWeight, minDist, lengthPenalty } = opts;
  const params = { nails, W, H, numLines, lineWeight, minDist, lengthPenalty };
  try {
    const r = await viaWorker({ type: "multi", maps, colors, params }, onProgress);
    return r.layers;
  } catch (e) {
    const layers = [];
    for (let i = 0; i < maps.length; i++) {
      // eslint-disable-next-line no-await-in-loop
      const seq = await generateSequence({
        error: maps[i],
        ...params,
        onProgress: (p) => onProgress && onProgress((i + p) / maps.length),
      });
      layers.push({ color: colors[i], sequence: seq });
    }
    return layers;
  }
}
